import React from 'react';

export const AdminEnemies: React.FC = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Enemy Management
      </h1>
      <p className="text-muted-foreground">
        Enemy management interface will be implemented here
      </p>
    </div>
  );
};